<template>
  <div id="instructions-container">
  
  </div>
</template>

<script>
export default {
  name: 'instructions',
  components:{},
  mounted(){},
  methods:{}
}
</script>
<style scoped src="../../../../../assets/css/components/new/home/index/instructions/Instructions.css"></style>